export const staffDivision = ['正社員', '派遣社員', 'アルバイト', 'バート'];
